class CustomerEdit {

    constructor(
        public id: number,
        public name: string,
        public phone: string,
        public downloadedLabels: number,
        public remainingLabels: number,
        public ownerFirstName?: string,
        public ownerLastName?: string,
    ) {
        this.id = id;
        this.name = name;
        this.phone = phone;
        this.ownerFirstName = ownerFirstName;
        this.ownerLastName = ownerLastName;
        this.downloadedLabels = downloadedLabels;
        this.remainingLabels = remainingLabels;
    }
}

export default CustomerEdit;
